export interface LoginLayoutRecoveryState {
    username: string
    error: string
    busy: boolean
    usernameInError: boolean
}
export const initialLoginLayoutRecoveryState =
    (): LoginLayoutRecoveryState => ({
        username: '',
        error: '',
        busy: false,
        usernameInError: false
    })
